import * as React from 'react';
import { get, sortBy } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

export default [
  {
    label: 'Jméno',
    field: 'label',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Dny',
    field: 'days',
    type: ColumnType.JSX,
    jsx: ({ row }) => {
      return (
        <div style={{ whiteSpace: 'nowrap' }}>
          {sortBy(get(row, 'weekDays', []), ['order']).map((dayObject: any) => (
            <span
              key={get(dayObject, 'id')}
              style={{
                borderBottom: `5px solid ${get(dayObject, 'day.color', 'transparent')}`,
                padding: `0 5px`
              }}
            >
              {get(dayObject, 'day.label')}
            </span>
          ))}
        </div>
      );
    }
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-templates/weeks/_weeksColumns.tsx